export function initFeatureVideo(): void {
  const players = document.querySelectorAll<HTMLElement>('.yt-player')
  players.forEach((player) => {
    player.addEventListener('click', () => {
      const id = player.dataset.ytId
      if (!id) return
      const params = new URLSearchParams({ autoplay: '1', playsinline: '1', rel: '0' })
      const iframe = document.createElement('iframe')
      iframe.src = `https://www.youtube.com/embed/${id}?${params}`
      iframe.allow = 'autoplay; encrypted-media'
      iframe.allowFullscreen = true
      Object.assign(iframe.style, { position: 'absolute', inset: '0', width: '100%', height: '100%', border: 'none' })
      player.style.position = 'relative'
      player.innerHTML = ''
      player.appendChild(iframe)
    })
  })
}
